export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14912.1d8fa91f.jpg";